export default "__VITE_ASSET__DqP7o3kB__"